import UrlHelper from "./UrlHelper";
export default async (url) => {
    let blobPromise;
    try {
        const source = UrlHelper(url);
        blobPromise = await fetch(source, { mode: 'cors', credentials: 'include'});
        if (blobPromise.ok) {
            const blobResult = blobPromise.blob();
            return (await blobResult);
        } else {
            return false;
        }
    } catch (errorInfo) {
        return false;
    }
}